import { getIsDateInRange, getMaxDate, getMinDate } from '@skytech/utils'

export function getIsActivationDateValid(activationDate: string | undefined) {
  if (!activationDate) return false
  return getIsDateInRange({
    minDate: getMinDate(3),
    maxDate: getMaxDate(12),
    options: {
      date: new Date(activationDate),
    },
  })
}
